import { render, staticRenderFns } from "./RegistrationDetailsNav.vue?vue&type=template&id=35fc91d2"
import script from "./RegistrationDetailsNav.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetailsNav.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports